<template>
  <div
    class="base-shadow bg-background-neutral-secondary divide-situational-lightgrey space-y-3 divide-y rounded-2xl border px-4 py-3"
    :class="[
      isMissing
        ? 'border-background-negative-primary'
        : 'border-background-neutral-primary',
    ]"
  >
    <div class="space-y-1">
      <div class="text-situational-darkgrey text-xs font-medium">
        {{ t('fareFamily.flight') }} {{ groupIdx + 1 }}
      </div>

      <div class="flex items-center justify-between space-x-2">
        <div class="text-text-neutral-primary font-semibold">
          {{ flightGroup.segments[0].dep.city }} →
          {{ flightGroup.segments[flightGroup.segments.length - 1].arr.city }}
        </div>
        <button
          type="button"
          class="text-button-primary-default text-sm font-medium"
          @click="emit('onOpenFlightDetails', { groupKey })"
        >
          {{ t('fareFamily.flightDetails') }}
        </button>
      </div>

      <div
        class="text-text-neutral-quaternary flex items-center space-x-2 text-xs"
      >
        <div class="flex items-center space-x-2">
          <div
            v-for="segment in flightGroup.segments"
            :key="`${segment.dep.airport}-${segment.arr.airport}`"
            class="flex items-center space-x-1"
          >
            <div>{{ segment.dep.airport }} — {{ segment.arr.airport }}</div>
            <AirlineIcon
              :airline="{ iata: segment.airline }"
              :size="AirlineIconSizeEnum.small"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="space-y-3 pt-3">
      <FareDescription
        v-if="!isNil(selectedFare)"
        :choice="selectedFare"
        :fare-idx="groupIdx"
        class="space-y-2"
      >
        <template #title="{ title }">
          <h3 class="text-text-neutral-primary font-bold">
            {{ title }}
          </h3>
        </template>
      </FareDescription>
      <FreeButton
        v-if="choices.length > 1"
        type="button"
        size="sm"
        class="w-full py-2 text-base font-semibold"
        :class="[!isNil(selectedFare) ? 'gray-button' : 'green-main-button']"
        @click="emit('onOpenFareSelect', { groupKey, groupIdx })"
      >
        {{
          !isNil(selectedFare)
            ? t('fareFamily.changeFare')
            : t('fareFamily.selectFare')
        }}
      </FreeButton>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { isNil } from 'lodash-es';
  import { AirlineIcon, AirlineIconSizeEnum, FreeButton } from 'freedom-shared';
  import type { ticketDetails } from 'freedom-shared';

  import type { FareFamilyChoiceSpec } from '../model';
  import FareDescription from './FareDescription.vue';

  type MappedFlight = ticketDetails.types.MappedFlight;

  defineProps<{
    groupKey: string;
    groupIdx: number;
    flightGroup: MappedFlight;
    choices: FareFamilyChoiceSpec[];
    selectedFare: FareFamilyChoiceSpec | null;
    isMissing: boolean;
  }>();

  const emit = defineEmits<{
    onOpenFlightDetails: [{ groupKey: string }];
    onOpenFareSelect: [{ groupKey: string; groupIdx: number }];
  }>();

  const { t } = useI18n();
</script>
